import { useMemo } from "react";
import { isStringTrue } from "@iddataweb/idw-common-ui/utils";
import { ToggleFormGroup } from "@containers/common/toggle-form-group/toggle-form-group";
import { LabelWidthTypes } from "@enums/label-width-types";
import { AxnAdminUserRpProperty } from "@idw-types/data/axn-admin-user/axn-admin-user-rp-property";
import { AxnRelyingParty } from "@idw-types/data/reference-data/axn";
import { AxnAdminAvailableUserProperty } from "@idw-types/data/axn-admin-available-user-property";

type RelyingPartyPermissionContainerProps = {
    isDisabled: boolean;
    userId: string;
    relyingParty: AxnRelyingParty;
    axnAdminAvailableUserRPProperty: AxnAdminAvailableUserProperty;
    axnAdminUserRpProperties: Array<AxnAdminUserRpProperty>;
    addRelyingPartyProperties: (
        rpProperties: Array<AxnAdminUserRpProperty>,
        relyingParty: AxnRelyingParty
    ) => void;
    removeRelyingPartyProperties: (
        rpProperties: Array<AxnAdminUserRpProperty>,
        relyingParty: AxnRelyingParty
    ) => void;
};

export const RelyingPartyPermissionContainer = (props: RelyingPartyPermissionContainerProps) => {
    const {
        isDisabled,
        relyingParty,
        userId,
        axnAdminAvailableUserRPProperty,
        axnAdminUserRpProperties,
        addRelyingPartyProperties,
        removeRelyingPartyProperties
    } = props;

    const property = useMemo(() => {
        return axnAdminUserRpProperties.find(rpProperty =>
            rpProperty.propertyName === axnAdminAvailableUserRPProperty.shortName &&
            rpProperty.relyingPartyID === relyingParty.id
        );
    }, [
        axnAdminAvailableUserRPProperty,
        axnAdminUserRpProperties,
        relyingParty
    ]);

    const propertyIsTrue = useMemo(() => {
        return !!property && isStringTrue(property.propertyValue);
    }, [property]);

    const onChangePropertyValue = () => {
        if (propertyIsTrue) {
            removeRelyingPartyProperties([property], relyingParty);
        } else {
            addRelyingPartyProperties([{
                id: null,
                propertyName: axnAdminAvailableUserRPProperty.shortName,
                propertyValue: "true",
                relyingPartyID: relyingParty.id,
                userID: userId
            }], relyingParty);
        }
    };

    return (
        <ToggleFormGroup
            checked={propertyIsTrue}
            labelWidth={LabelWidthTypes.LARGE}
            controlId={`relying-party-${relyingParty.id}-property-${axnAdminAvailableUserRPProperty.shortName}`}
            disabled={isDisabled}
            isRequired={false}
            label={axnAdminAvailableUserRPProperty.name}
            value={`${propertyIsTrue}`}
            onChange={onChangePropertyValue}
            afterLabelTooltipText={axnAdminAvailableUserRPProperty.description}
        />
    );
}